"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typescriptParameterTypesReflectKey = void 0;
exports.typescriptParameterTypesReflectKey = 'design:paramtypes';
//# sourceMappingURL=typescriptDesignParameterTypesReflectKey.js.map